<template>
  <v-layout
    row
    wrap
    mt-3
  >
    <p class="fw-600 f-1 required-block mb-0 mt-3">
      3. {{ $t('warehouses.locationData.warehouse_opening') }}
    </p>
    <p class="font-weight-regular f-16">
      {{ $t('warehouses.locationData.opening_hours_hint') }}
    </p>
    <v-flex
      xs12
      sm10
    >
      <v-layout
        align-center
        justify-space-between
        row
        fill-height
        wrap
        :class="{ 'light-disabled': warehouseType === 1 && additionalFirstDayChecked !== 'yes' }"
      >
        <v-flex
          v-if="warehouseType === 1"
          xs2
          sm1
        >
          <v-checkbox
            v-model="additionalFirstDayChecked"
            :disabled="readOnly"
            true-value="yes"
            false-value="no"
          />
        </v-flex>
        <v-flex
          :class="warehouseType === 1 ? 'xs10 sm6' : 'xs12 sm7'"
          :pr-5="!xsOnly"
        >
          <v-text-field
            disabled
            :placeholder="days[0].description"
          />
        </v-flex>
        <v-flex
          xs12
          sm5
        >
          <v-layout
            align-center
            row
            fill-height
          >
            <v-text-field
              v-model="firstDayFrom"
              v-validate="{ rules: { required: firstRequired, is_time: true } }"
              :required="firstRequired"
              :error-messages="errors.collect('firstDayFrom')"
              :data-vv-as="' '"
              :data-vv-name="'firstDayFrom'"
              mask="##:##"
              append-icon="access_time"
              :disabled="(warehouseType === 1 && additionalFirstDayChecked !== 'yes') || readOnly"
              inputmode="numeric"
              @blur="checkTime('firstDayFrom')"
              @input="emitOpeningHours"
            />
            <span class="f-1 mt-1 mx-3">do</span>
            <v-text-field
              v-model="firstDayTo"
              v-validate="{ rules: { required: firstRequired, is_time: true } }"
              :required="firstRequired"
              :error-messages="errors.collect('firstDayTo')"
              :data-vv-as="' '"
              :data-vv-name="'firstDayTo'"
              mask="##:##"
              append-icon="access_time"
              :disabled="(warehouseType === 1 && additionalFirstDayChecked !== 'yes') || readOnly"
              inputmode="numeric"
              @blur="checkTime('firstDayTo')"
              @input="emitOpeningHours"
            />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      mt-1
      sm10
    >
      <v-divider v-if="xsOnly" />
      <v-layout
        align-center
        justify-space-between
        row
        fill-height
        wrap
      >
        <v-flex
          xs12
          sm7
          :pr-5="!xsOnly"
        >
          <v-text-field
            disabled
            :placeholder="days[1].description"
          />
        </v-flex>
        <v-flex
          xs12
          sm5
        >
          <v-layout
            align-center
            row
            fill-height
          >
            <v-text-field
              v-model="secondDayFrom"
              v-validate="'required|is_time'"
              :error-messages="errors.collect('secondDayFrom')"
              :data-vv-as="' '"
              :data-vv-name="'secondDayFrom'"
              mask="##:##"
              append-icon="access_time"
              :disabled="readOnly"
              inputmode="numeric"
              @blur="checkTime('secondDayFrom')"
              @input="emitOpeningHours"
            />
            <span class="f-1 mt-1 mx-3">do</span>
            <v-text-field
              v-model="secondDayTo"
              v-validate="'required|is_time'"
              :error-messages="errors.collect('secondDayTo')"
              :data-vv-as="' '"
              :data-vv-name="'secondDayTo'"
              mask="##:##"
              append-icon="access_time"
              :disabled="readOnly"
              inputmode="numeric"
              @blur="checkTime('secondDayTo')"
              @input="emitOpeningHours"
            />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      v-if="warehouseType === 1"
      xs12
      mt-1
      sm10
    >
      <v-divider v-if="xsOnly" />
      <v-layout
        align-center
        justify-space-between
        row
        fill-height
        wrap
        :class="{ 'light-disabled': warehouseType === 1 && additionalThirdDayChecked !== 'yes' }"
      >
        <v-flex
          xs2
          sm1
        >
          <v-checkbox
            v-model="additionalThirdDayChecked"
            true-value="yes"
            false-value="no"
          />
        </v-flex>
        <v-flex
          class="xs10 sm6"
          :pr-5="!xsOnly"
        >
          <v-text-field
            disabled
            :placeholder="days[2].description"
          />
        </v-flex>
        <v-flex
          xs12
          sm5
        >
          <v-layout
            align-center
            row
            fill-height
          >
            <v-text-field
              v-model="thirdDayFrom"
              v-validate="{ rules: { required: lastDayRequired, is_time: true } }"
              :required="lastDayRequired"
              :error-messages="errors.collect('thirdDayFrom')"
              :data-vv-as="' '"
              :data-vv-name="'thirdDayFrom'"
              mask="##:##"
              append-icon="access_time"
              :disabled="(warehouseType === 1 && additionalThirdDayChecked !== 'yes') || readOnly"
              inputmode="numeric"
              @blur="checkTime('thirdDayFrom')"
              @input="emitOpeningHours"
            />
            <span class="f-1 mt-1 mx-3">do</span>
            <v-text-field
              v-model="thirdDayTo"
              v-validate="{ rules: { required: lastDayRequired, is_time: true } }"
              :required="lastDayRequired"
              :error-messages="errors.collect('thirdDayTo')"
              :data-vv-as="' '"
              :data-vv-name="'thirdDayTo'"
              mask="##:##"
              append-icon="access_time"
              :disabled="(warehouseType === 1 && additionalThirdDayChecked !== 'yes') || readOnly"
              inputmode="numeric"
              @blur="checkTime('thirdDayTo')"
              @input="emitOpeningHours"
            />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'warehouses/getHours',
    mutationType: 'warehouses/updateHours'
});

export default {
    name: 'OpeningHours',
    inject: ['$validator'],
    props: {
        warehouseType: {
            required: true,
            type: Number
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapFields([
            'firstDayFrom',
            'firstDayTo',
            'secondDayFrom',
            'secondDayTo',
            'thirdDayFrom',
            'thirdDayTo',
            'additionalFirstDayChecked',
            'additionalThirdDayChecked'
        ]),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        days () {
            return this.$store.getters['warehouses/getResource'].find((el) => {
                return el.id === 1003;
            }).resources;
        },
        firstRequired () {
            if (this.warehouseType === 2) {
                return true;
            } else {
                return this.additionalFirstDayChecked === 'yes';
            }
        },
        lastDayRequired () {
            return this.additionalThirdDayChecked === 'yes';
        }
    },
    watch: {
        additionalFirstDayChecked (val) {
            if (val === 'no' && this.warehouseType === 1) {
                this.firstDayFrom = null;
                this.firstDayTo = null;
            }
            this.emitOpeningHours();
        },
        additionalThirdDayChecked (val) {
            if (val === 'no' && this.warehouseType === 1) {
                this.thirdDayFrom = null;
                this.thirdDayTo = null;
            }
            this.emitOpeningHours();
        }
    },
    methods: {
        checkTime (name) {
            if (this[name] == null) {
                return;
            }
            if (this[name].length === 3) {
                this[name] = '0' + this[name];
            }
            this.$nextTick(() => {
                this.$validator.validate(name, this[name]);
            });
            this.emitOpeningHours();
        },
        emitOpeningHours () {
            const hours = {
                firstDayFrom: this.firstDayFrom,
                firstDayTo: this.firstDayTo,
                secondDayFrom: this.secondDayFrom,
                secondDayTo: this.secondDayTo,
                thirdDayFrom: this.thirdDayFrom,
                thirdDayTo: this.thirdDayTo,
                additionalFirstDayChecked: this.additionalFirstDayChecked,
                additionalThirdDayChecked: this.additionalThirdDayChecked
            };
            this.$emit('emitHours', hours);
        }
    }
};
</script>

<style scoped></style>
